export var SettingKeySeparator = '_';
export var CustomPivotSettingKeyPrefix = 'CustomPivot';
export var LayoutPreferenceSettingKey = 'LayoutPref';
export var PinnedPeopleSettingKey = 'PinnedPeopleIds';
export var CustomPivotTabIdSeparator = '-';
export var PendingCustomPivotId = 'custom-pivot-pending';
//# sourceMappingURL=Constants.js.map